import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import { ENVIRONMENT } from '../../../../core/tokens/app.tokens';
import type { SubmitReportDto } from '../../models/report.dto';
import type { IReportProvider } from './i-report.provider';

@Injectable()
export class HttpReportProvider implements IReportProvider {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);

  fetchCategories(): Observable<readonly string[]> {
    return this.http.get<readonly string[]>(`${this.env.apiUrl}/sessionreports/categories`);
  }

  submit(sessionId: string | undefined, dto: SubmitReportDto): Observable<void> {
    const route = sessionId
      ? `${this.env.apiUrl}/sessionreports/${sessionId}`
      : `${this.env.apiUrl}/sessionreports`;

    return this.http.post<void>(route, dto);
  }
}
